// M2g285: a SCRATCH session applies filters, sorts and groups to a table page WITHOUT writing any saved view on the
// server. `?scratch=1` on the page URL turns it on for this tab (`?scratch=0` turns it off). The flag is kept in
// sessionStorage so it survives the in-app navigation that drops the query string.
//
// Why it is read here, at load, and imported by src/index.js: App loads its pages lazily, so a table's own module
// (and any read of the flag inside it) is evaluated only after the login and the menu have already dropped the query
// string. The first M2g285 walk read the flag then, found it gone, and saved the shared kaiadmin Grid view anyway.
//
// A walk that applies conditions to that shared view used to auto-save them into the row (prefs and is_active), so
// the next walk started from a mutated baseline. In a scratch session no create, update, activate, delete or reorder
// reaches /table-views (see useSavedViews.js); the page's own filter and sort still apply, and the edit stays local.
const SCRATCH_KEY = "tableViews.scratch";

export const scratchSession = () => {
  try {
    const m = /[?&]scratch=([01])(?:&|$)/.exec(window.location.search);
    if (m) sessionStorage.setItem(SCRATCH_KEY, m[1] === "1" ? "1" : "0");
    return sessionStorage.getItem(SCRATCH_KEY) === "1";
  } catch {
    return false;
  }
};

if (typeof window !== "undefined") scratchSession();
